// EmsTable.jsx - EMS控制器遥测数据表（直接显示所有字段）
import React from 'react';
import { Table } from 'antd';
import { useTranslation } from '../../../../utils/useI18n';

const COLORS = { primary: '#00d4ff', muted: 'rgba(255,255,255,0.6)' };

const EmsTable = ({ data }) => {
  const { t } = useTranslation();

  const columns = [
    { title: 'SN', dataIndex: 'sn', key: 'sn', width: 100, render: v => <span style={{ color: COLORS.primary }}>{v || '-'}</span> },
    { title: t('cloud.online'), dataIndex: 'online', key: 'online', width: 70, render: v => v === 1 ? <span style={{ color: '#52c41a' }}>●</span> : <span style={{ color: '#999' }}>○</span> },
    { title: t('cloud.state'), dataIndex: 'state', key: 'state', width: 100, render: v => v || '-' },
    { title: t('cloud.globalNo'), dataIndex: 'global_no', key: 'global_no', width: 120, render: v => v || '-' },
    { title: t('cloud.deviceType'), dataIndex: 'device_type', key: 'device_type', width: 100, render: v => v || '-' },
    { title: t('cloud.type'), dataIndex: 'type', key: 'type', width: 100, render: v => v || '-' },
    { title: 'SOC %', dataIndex: 'soc', key: 'soc', width: 80, render: v => v != null ? `${v}` : '-' },
    { title: t('cloud.gridPower')+'(kW)', dataIndex: 'grid_power_kw', key: 'grid_power_kw', width: 110, render: v => v != null ? `${v}` : '-' },
    { title: t('cloud.pcsPower')+'(kW)', dataIndex: 'pcs_power_kw', key: 'pcs_power_kw', width: 110, render: v => v != null ? `${v}` : '-' },
    { title: t('cloud.pvPower')+'(kW)', dataIndex: 'pv_power_kw', key: 'pv_power_kw', width: 110, render: v => v != null ? `${v}` : '-' },
    { title: t('cloud.loadPower')+'(kW)', dataIndex: 'load_power_kw', key: 'load_power_kw', width: 110, render: v => v != null ? `${v}` : '-' },
    { title: t('cloud.maxChargePower')+'(kW)', dataIndex: 'max_charge_power_kw', key: 'max_charge_power_kw', width: 130, render: v => v != null ? `${v}` : '-' },
    { title: t('cloud.maxDischargePower')+'(kW)', dataIndex: 'max_discharge_power_kw', key: 'max_discharge_power_kw', width: 140, render: v => v != null ? `${v}` : '-' },
    { title: t('cloud.systemStatus'), dataIndex: 'system_status', key: 'system_status', width: 100, render: v => v ?? '-' },
    { title: t('cloud.pcsOnOffState'), dataIndex: 'pcs_onoff_state', key: 'pcs_onoff_state', width: 120, render: v => v ?? '-' },
    { title: t('cloud.onoffStatus'), dataIndex: 'onoff_status', key: 'onoff_status', width: 90, render: v => v || '-' },
    { title: t('cloud.gridState'), dataIndex: 'grid_state', key: 'grid_state', width: 90, render: v => v ?? '-' },
    { title: t('cloud.gridMode'), dataIndex: 'grid_mode', key: 'grid_mode', width: 90, render: v => v || '-' },
    { title: t('cloud.chargeKwh'), dataIndex: 'charge_kwh', key: 'charge_kwh', width: 100, render: v => v != null ? `${v}` : '-' },
    { title: t('cloud.dischargeKwh'), dataIndex: 'discharge_kwh', key: 'discharge_kwh', width: 110, render: v => v != null ? `${v}` : '-' },
    { title: t('cloud.chargeTotalKwh'), dataIndex: 'charge_total_kwh', key: 'charge_total_kwh', width: 120, render: v => v != null ? `${v}` : '-' },
    { title: t('cloud.dischargeTotalKwh'), dataIndex: 'discharge_total_kwh', key: 'discharge_total_kwh', width: 130, render: v => v != null ? `${v}` : '-' },
    { title: 'message_id', dataIndex: 'message_id', key: 'message_id', width: 160, render: v => v || '-' },
    { title: t('cloud.recordedAt'), dataIndex: 'recorded_at', key: 'recorded_at', width: 160, render: v => v ? new Date(v).toLocaleString() : '-' },
  ];

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ color: COLORS.muted, fontSize: 12, marginBottom: 8 }}>{t('cloud.emsTelemetry')}</div>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        pagination={{ pageSize: 5, showSizeChanger: false }}
        scroll={{ x: 2400 }}
        style={{ background: 'transparent' }}
      />
    </div>
  );
};

export default EmsTable;
